import SvgIcons from "../../../shared/components/svgIcons";
import DashboardCharts from "../components/dashboard-graphs";

const graphsRoute = [
  {
    path: "graphs",
    element: <DashboardCharts />,
    link: "graphs",
    name: "Graphs",
    icon: SvgIcons.DashBoardIcon,
    index: 2,
  },
];
export default graphsRoute;
